import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-black border-b border-yellow-500 w-full shadow-lg shadow-yellow-900/20" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4 text-center sm:text-left" data-id="element-54">
        {/* Left Side: Alert */}
        <div className="flex items-center justify-center sm:justify-start gap-3" data-id="element-55">
          <span className="relative flex h-3 w-3" data-id="element-56">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-57"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-58"></span>
          </span>
          <p className="text-white text-sm sm:text-base font-medium" data-id="element-59">
            <span className="text-yellow-400 font-bold" data-id="element-60">OFERTA LIMITADA:</span>{' '}
            Solo quedan 7 copias disponibles
          </p>
        </div>

        {/* Right Side: Timer */}
        <div className="flex items-center gap-3" data-id="element-61">
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold hidden sm:inline" data-id="element-62">
            Expira en:
          </span>
          <CountdownTimer data-id="element-63" />
        </div>
      </div>
    </div>;
}